const Dashboard = () => import("../layouts/dashboard.vue");
const AppConfig = () => import("../pages/config.vue");

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export const configRoutes = [
  {
    path: "/gerenciador",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: AppConfig,
      },
    ],
  },
];
